import { PropsWithChildren, ReactNode } from "react";

import { Flex, FlexProps } from "@chakra-ui/react";

import ActionMenu from "@/components/shared/ActionMenu";

function Content({
  actionFooter,
  children,
  ...props
}: PropsWithChildren<{ actionFooter?: ReactNode }> & FlexProps) {
  return (
    <Flex direction="column" h="full">
      <Flex
        direction="column"
        flex={1}
        p={6}
        rowGap={5}
        {...props}
        overflow="hidden auto"
        position="relative"
        tabIndex={0}
      >
        {children}
      </Flex>
      {actionFooter && <ActionMenu>{actionFooter}</ActionMenu>}
    </Flex>
  );
}

export default Content;
